<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Attendance Approval"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <div class="d-flex align-items-center justify-content-between filter-label">
                  <label for="colFormLabel" class="col-form-label">Employee: </label>
                </div>
                <AsyncSelect
                    placeholder="Select Employee"
                    v-model="contactProfileId"
                    :api-service="fetchContactProfiles"
                    :additional-query="{ type: 'employee', status: 'active'}"
                />
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <label class="col-form-label">Approval Status</label>
                <v-select
                    placeholder="Select Status"
                    v-model="approvalStatus"
                    :options="approvalStatusList"
                    :reduce="name => name.value"
                    label="name"
                />
              </div>
            </DateQuerySetter>
        </div>

      <div class="col-12" v-if="false">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="exportTable"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
          >
            Export
          </button>
        </div>
      </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <ListTable  :tableItems="tableItems" :getAttendanceList="getAttendanceList" />
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import ListTable from '@/components/molecule/company/hrm-payroll/attendance-approval/ListTable.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleContact from '@/services/modules/contact'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
    offset: 10,
});
const approvalStatusList = ref([]);
const contactProfileId = ref('');
const approvalStatus = ref('');
let contacts = ref([])

const token = computed(() => localStorage.getItem('token'));

const {
  fetchAttendanceApproval,
  fetchTypes
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact()

const onClickToGo = () => {
  getAttendanceList();
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getAttendanceList();
}
const getAttendanceList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchAttendanceApproval(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }

        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    if (contactProfileId.value) query += '&contact_profile_id=' + contactProfileId.value.id
    if (approvalStatus.value) query += '&status=' + approvalStatus.value;
    if (!approvalStatus.value) query += '&status=pending';
    query += '&offset=' + params.value.offset
    return query;
}

const exportTable = () => {
  let query = getQuery();
  let url = `${process.env.VUE_APP_BASE_URL}/api/hr-payroll/attendance-log-summary${query}&_token=${token.value}&is_export=1`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
};

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      approvalStatusList.value = [];
      return
    }

    if (res.data && res.data.attendanceApprovalStatus) {
      approvalStatusList.value = res.data.attendanceApprovalStatus;
    }

  }).catch(err => {
    console.log(err)
  })
}

onMounted(() => {
    Promise.all([
      getAttendanceList(),
      getTypes()
    ])
})
</script>
